import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useLoader } from '../../../Loader/LoaderContext';
import { API_ENDPOINTS } from '../../../api';
import {
  getService,
  postService,
  putService,
} from '../../../servce/ApisService';
import {
  getDotColor,
  getDotColors,
  getStatusClasses,
  getStatusDisplayName,
  getStatusDisplayNames,
} from '../../../utility/RolesUtility';
import DateService from '../../../servce/DateService';
import Pagination from '../usersMangmnt/Pagination';
import DynamicTextPopup from '../Modals/dynamicTextPopup';

function ViewPaymentDetails() {
  const [isOpen, setMarkAsPaid] = useState(false);
  const [data, setData] = useState<any>(null);
  const [isNewProposal, setNewProposal] = useState(false);
  const router = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('appUserId');
  const vendorUserUuId = searchParams.get('vendorUUID');
  const type = searchParams.get('vendorUUID');
  const [totalElement, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [tableData, setTableData] = useState<any>([]);
  const { setLoading } = useLoader();
  const [numberOfElements, setNumberOfElements] = useState('');
  useEffect(() => {
    fetchDetails();
  }, [currentPage]);
  const fetchDetails = async () => {
    try {
      setLoading(true);
      let url: any;
      url = API_ENDPOINTS.getProposalBooking;
      let body = {
        page: currentPage,
        vendorId: userId,
      };
      const response = await postService(url, body);
      const isNewProposal = response.data.content.some(
        (proposal: any) =>
          proposal?.status === 'YET_TO_SIGN' &&
          !proposal?.bookingReqOn &&
          proposal?.proposalType === 'PROPOSAL'
      );
      const isActivateDashboard = response.data.content.some(
        (proposal: any) => proposal?.status === 'ACTIVE'
      );
      // localStorage.setItem('activteDashboard',isActivateDashboard)
      setNewProposal(isNewProposal);
      console.log(isNewProposal);

      setNumberOfElements(response.data.numberOfElements);
      setTableData(response.data.content);
      setTotalPages(response.data.totalPages);

      setTotalElements(response.data.totalElements);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      console.error('Error fetching data:', error);
    }
  };

  const handleDownloadBookingForm = async (user: any) => {
    let apiUrl = '';
    function base64ToArrayBuffer(base64: string) {
      const binaryString = window.atob(base64); // Decode base64 string
      const len = binaryString.length;
      const bytes = new Uint8Array(len); // Create a Uint8Array from binary string
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i); // Convert each char to binary
      }
      return bytes.buffer;
    }

    // apiUrl = API_ENDPOINTS.getBookingForm;

    try {
      const response = await getService(`${apiUrl}?bookingId=${user?.id}`);

      // Check if response data exists and contains base64 string
      if (response.data && response.data.base64Str) {
        // Convert the base64 string into a Blob URL for downloading
        const arrayBuffer = base64ToArrayBuffer(response.data.base64Str);
        const downloadUrl = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: 'application/pdf' })
        );

        // Create an anchor element to trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', response.data.name || 'bookingForm.pdf'); // Set filename
        document.body.appendChild(link);
        link.click();

        // Cleanup: Remove the link and revoke the Blob URL
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        console.error('No valid base64 string found in the response data');
      }
    } catch (error) {
      console.error('Error downloading the order form:', error);
    }
  };
  const confirmMarkAsPaid = async () => {
    try {
      setLoading(true);
      let url: any;
      const response = await putService(
        API_ENDPOINTS.markAdPaid + '?proposalId=' + data?.id,
        {}
      );
      setMarkAsPaid(false);
      fetchDetails();
    } catch {
    } finally {
      setLoading(false);
    }
  };
  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };
  const onPageChange = async (page: number) => {
    setCurrentPage(page);
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };
  const users = () => {
    if (path === '/portals/vendors/activeVendor/viewPaymentsDetails') {
      router('/portals/vendors/activeVendor/');
    } else {
      router('/portals/vendors/inActiveVendor/');
    }
  };
  const downloadInvoice = async (data: any) => {
    setLoading(true);
    let apiUrl = '';
    function base64ToArrayBuffer(base64: string) {
      const binaryString = window.atob(base64); // Decode base64 string
      const len = binaryString.length;
      const bytes = new Uint8Array(len); // Create a Uint8Array from binary string
      for (let i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i); // Convert each char to binary
      }
      return bytes.buffer;
    }
    apiUrl = API_ENDPOINTS.getInvoice;
    try {
      const response = await getService(`${apiUrl}?proposalId=${data?.id}`);
      if (response.data && response.data.base64Str) {
        // Convert the base64 string into a Blob URL for downloading
        const arrayBuffer = base64ToArrayBuffer(response.data.base64Str);
        const downloadUrl = window.URL.createObjectURL(
          new Blob([arrayBuffer], { type: 'application/pdf' })
        );
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', response.data.name || 'bookingForm.pdf'); // Set filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        console.error('No valid base64 string found in the response data');
      }
    } catch (error) {
      console.error('Error downloading the order form:', error);
    } finally {
      setLoading(false);
    }
  };
  const markAsPaid = (data: any) => {
    setData(data);
    setMarkAsPaid(true);
  };
  return (
    <div className='h-full py-2 w-full'>
      <div className='flex items-center cursor-pointer mb-4'>
        <h2
          className='mr-2 text-gray-700 font-semibold text-sm'
          onClick={users}
        >
          {path === '/portals/vendors/activeVendor/viewPaymentsDetails'
            ? 'Active Vendors'
            : 'Inactive Vendors'}
        </h2>
        <img src='/images/arrowIcons.svg' className='mr-2' />
        <span className='text-gray-400 font-semibold text-sm'>
          {tableData[0]?.companyName} (#{vendorUserUuId})
        </span>
      </div>
      <div
        className='flex gap-2 items-center font-sans pb-5 cursor-pointer'
        onClick={users}
      >
        <img src='/images/Back or Arrow left (1).svg' />
        <p className='text-[#2D2E2F] font-bold text-2xl'>
          {tableData[0]?.companyName} (#{vendorUserUuId})
        </p>
      </div>
      <div className=' bg-pink-Bg-color py-2'>
        <p className='text-[#161C2D] font-bold text-2xl'>
          Proposals and Payments
        </p>
        {/* <p className='text-black font-normal text-xl'>Manage your proposals and track payment status.</p> */}
      </div>

      <div className='bg-white md:px-10 py-12 '>
        <div className='overflow-x-auto bg-white rounded'>
          <table className='w-full border-collapse border border-[#EAECF0]'>
            <thead className='bg-[#FFF9F9]'>
              <tr className='text-left'>
                <th className='border p-3 px-6 text-gray-800 font-bold text-sm'>
                  #
                </th>
                <th className='border p-3 px-6 text-gray-800 font-bold text-sm'>
                  Proposal Status
                </th>
                <th className='border p-3 px-6 text-gray-800 font-bold text-sm'>
                  Date of Signing
                </th>
                <th className='border p-3 px-6 text-gray-800 font-bold text-sm'>
                  Invoice Status
                </th>
                <th className='border p-3 px-6 text-gray-800 font-bold text-sm'>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((proposal: any, index: number) => (
                <tr
                  key={index}
                  className=' hover:bg-gray-50 font-medium text-xs cursor-pointer'
                >
                  <td className='border p-3 px-6 text-[#101828]'>
                    {proposal?.uuid}
                  </td>

                  <td
                    className={`border p-3 px-6 text-sm font-medium text-[#101828]`}
                  >
                    {proposal?.status === 'YET_TO_SIGN' &&
                    !proposal.bookingReqOn ? (
                      <div className='flex  items-center'>
                        <span
                          className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClasses(
                            proposal?.isDeclined ? 'DECLINED' : proposal?.status
                          )}`}
                        >
                          <span
                            className='inline-block w-2 h-2 mr-2 rounded-full'
                            style={{
                              backgroundColor: getDotColors(
                                proposal?.isDeclined
                                  ? 'DECLINED'
                                  : proposal?.status
                              ),
                            }}
                          ></span>

                          {getStatusDisplayNames(
                            proposal?.isDeclined ? 'DECLINED' : proposal?.status
                          )}
                        </span>
                        <span
                          onClick={() => handleDownloadBookingForm(proposal)}
                        >
                          <img
                            src='/images/downloadBookForm.svg'
                            className='ml-2'
                          />
                        </span>
                      </div>
                    ) : proposal?.status === 'YET_TO_SIGN' &&
                      proposal.bookingReqOn &&
                      proposal?.proposalType === 'PROPOSAL' ? (
                      <span className=' text-xs font-medium text-[#101828]'>
                        Booking Requested{' '}
                      </span>
                    ) : proposal?.status === 'YET_TO_SIGN' &&
                      proposal?.proposalType === 'BOOKED' ? (
                      <span className=' text-xs font-medium text-[#101828] flex items-center'>
                        Order Form Received{' '}
                        <span
                          onClick={() => handleDownloadBookingForm(proposal)}
                        >
                          <img
                            src='/images/downloadBookForm.svg'
                            className='ml-2'
                          />
                        </span>{' '}
                      </span>
                    ) : proposal?.status === 'CONFIRM' ? (
                      <div className='flex  items-center'>
                        <span
                          className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClasses(
                            proposal?.status
                          )}`}
                        >
                          <span
                            className='inline-block w-2 h-2 mr-2 rounded-full'
                            style={{
                              backgroundColor: getDotColors(proposal?.status),
                            }}
                          ></span>

                          {getStatusDisplayNames(proposal?.status)}
                        </span>
                      </div>
                    ) : (
                      <div className='flex  items-center'>
                        <span
                          className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClasses(
                            proposal?.status === 'ACTIVE' &&
                              proposal?.paymentStatus == 'PAID' &&
                              proposal?.type === 'PAID'
                              ? 'ACTIVE'
                              : proposal?.isDeclined
                              ? 'DECLINED'
                              : proposal?.status
                          )}`}
                        >
                          <span
                            className='inline-block w-2 h-2 mr-2 rounded-full'
                            style={{
                              backgroundColor: getDotColors(
                                proposal?.status === 'ACTIVE' &&
                                  proposal?.paymentStatus == 'PAID' &&
                                  proposal?.type === 'PAID'
                                  ? 'ACTIVE'
                                  : proposal?.isDeclined
                                  ? 'DECLINED'
                                  : proposal?.status
                              ),
                            }}
                          ></span>

                          {getStatusDisplayNames(
                            proposal?.status === 'ACTIVE' &&
                              proposal?.paymentStatus == 'PAID' &&
                              proposal?.type === 'PAID'
                              ? 'ACTIVE'
                              : proposal?.isDeclined
                              ? 'DECLINED'
                              : proposal?.status
                          )}
                        </span>
                      </div>
                    )}
                  </td>
                  <td className='border p-3 px-6 text-[#667085]'>
                    {proposal.formUploadedOn
                      ? DateService.formatDate(
                          proposal.formUploadedOn,
                          DateService.formats.DD_MM__YYYY
                        )
                      : '-'}
                  </td>
                  <td className={`border p-3  px-6 text-sm font-medium`}>
                    {proposal?.type === 'PAID' ? (
                      <div className='flex  items-center'>
                        <span
                          className={`px-3 py-1.5 rounded-full text-xs font-semibold ${getStatusClasses(
                            (proposal?.status === 'ACTIVE' &&
                              proposal?.paymentStatus == 'PAID' &&
                              proposal?.type === 'PAID') ||
                              (proposal?.status === 'EXPIRED' &&
                                proposal?.paymentStatus == 'PAID' &&
                                proposal?.type === 'PAID') ||
                              proposal?.paymentStatus === 'MARK_AS_PAID'
                              ? 'ACTIVE'
                              : proposal?.status === 'ACTIVE' ||
                                (proposal?.status === 'EXPIRED' &&
                                  proposal?.paymentStatus !== 'PAID')
                              ? 'UNPAID'
                              : 'NOTGENERATED'
                          )}`}
                        >
                          <span
                            className='inline-block w-2 h-2 mr-2 rounded-full'
                            style={{
                              backgroundColor: getDotColors(
                                (proposal?.status === 'ACTIVE' &&
                                  proposal?.paymentStatus == 'PAID' &&
                                  proposal?.type === 'PAID') ||
                                  proposal?.paymentStatus === 'MARK_AS_PAID' ||
                                  proposal?.paymentStatus == 'PAID'
                                  ? 'ACTIVE'
                                  : proposal?.status === 'ACTIVE' ||
                                    (proposal?.status === 'EXPIRED' &&
                                      proposal?.paymentStatus !== 'PAID')
                                  ? 'UNPAID'
                                  : 'NOTGENERATED'
                              ),
                            }}
                          ></span>

                          {getStatusDisplayNames(
                            (proposal?.status === 'ACTIVE' &&
                              proposal?.paymentStatus == 'PAID' &&
                              proposal?.type === 'PAID') ||
                              proposal?.paymentStatus == 'PAID' ||
                              proposal?.paymentStatus === 'MARK_AS_PAID'
                              ? 'PAID'
                              : proposal?.status === 'ACTIVE' ||
                                (proposal?.status === 'EXPIRED' &&
                                  proposal?.paymentStatus !== 'PAID')
                              ? 'UNPAID'
                              : 'NOTGENERATED'
                          )}
                        </span>
                        {(proposal?.status === 'ACTIVE' ||
                          proposal?.paymentStatus === 'MARK_AS_PAID' ||
                          (proposal?.paymentStatus == 'PAID' &&
                            proposal?.status === 'EXPIRED')) && (
                          <span onClick={() => downloadInvoice(proposal)}>
                            <img
                              src='/images/downloadBookForm.svg'
                              className='ml-2'
                            />
                          </span>
                        )}
                      </div>
                    ) : (
                      '-'
                    )}
                  </td>
                  <td className='border p-3 px-6'>
                    {proposal?.status === 'YET_TO_SIGN' &&
                    !proposal?.bookingReqOn &&
                    proposal?.proposalType === 'PROPOSAL' ? (
                      <span className='text-[#101828] text-sm  font-normal cursor-pointer'>
                        Request Order form
                      </span>
                    ) : (proposal?.status === 'YET_TO_SIGN' &&
                        proposal.bookingReqOn &&
                        proposal?.proposalType === 'PROPOSAL') ||
                      (proposal?.status === 'EXPIRED' &&
                        proposal?.paymentStatus !== 'PAID' &&
                        proposal?.paymentStatus !== 'MARK_AS_PAID') ? (
                      <span>- </span>
                    ) : proposal?.status === 'YET_TO_SIGN' &&
                      proposal?.proposalType === 'BOOKED' ? (
                      <span className='text-[#101828] text-sm  font-normal cursor-pointer'>
                        Upload Signed Order Form
                      </span>
                    ) : proposal?.status === 'CONFIRM' ? (
                      <span className='text-[#101828] text-sm  font-normal cursor-pointer'>
                        -
                      </span>
                    ) : proposal?.status === 'ACTIVE' &&
                      proposal?.paymentStatus !== 'PAID' &&
                      proposal?.paymentStatus !== 'MARK_AS_PAID' &&
                      proposal?.type === 'PAID' ? (
                      <button
                        className='bg-custom-gradients text-white font-semibold text-sm rounded-md p-2'
                        onClick={() => markAsPaid(proposal)}
                      >
                        Mark as paid{' '}
                      </button>
                    ) : proposal?.paymentStatus === 'MARK_AS_PAID' ? (
                      `Marked as paid on ${
                        proposal?.paidOn
                          ? DateService.formatDate(
                              proposal?.paidOn,
                              DateService.formats.DD_MM_YYYY
                            )
                          : ''
                      }`
                    ) : proposal?.paymentStatus == 'PAID' &&
                      proposal?.type === 'PAID' ? (
                      `Paid on ${
                        proposal?.paidOn
                          ? DateService.formatDate(
                              proposal?.paidOn,
                              DateService.formats.DD_MM_YYYY
                            )
                          : ''
                      }`
                    ) : (
                      '-'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalElement={totalElement}
          onPageChange={onPageChange}
          onNext={onNext}
          onPrevious={onPrevious}
        />
      )}
      {isOpen && (
        <DynamicTextPopup
          onClose={() => setMarkAsPaid(false)}
          title='Mark Invoice as Paid'
          body='Are you sure you want to mark this invoice as paid? Once confirmed, the invoice will be updated as Paid, and the vendor will be notified accordingly. This action cannot be undone.'
          confirmButtonName=' Yes, Mark as Paid'
          closeButtonName='Cancel'
          onConfirm={confirmMarkAsPaid}
        />
      )}
    </div>
  );
}
export default ViewPaymentDetails;
